var _PoweredBy, _CrehanaPremium, _CrehanaMicroDegree, _Crehana;
import { useMemo } from "react";
import Crehana from "@crehana/icons/logos/Crehana";
import CrehanaMicroDegree from "@crehana/icons/logos/CrehanaMicroDegree";
import CrehanaPremium from "@crehana/icons/logos/CrehanaPremium";
import PoweredBy from "../PoweredBy";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var Logo = function Logo(_ref) {
  var _ref$targetLink = _ref.targetLink,
    targetLink = _ref$targetLink === void 0 ? '_self' : _ref$targetLink,
    user = _ref.user,
    urls = _ref.urls;
  var logoType = useMemo(function () {
    if (user) {
      if (user.isB2B) {
        return 'b2b';
      }
      if (user.isActiveDegree) {
        return 'microdegree';
      }
      if (user.isPremium) {
        return 'premium';
      }
    }
    return 'default';
  }, [user]);
  var renderLogo = function renderLogo() {
    if (logoType === 'b2b') {
      return _PoweredBy || (_PoweredBy = /*#__PURE__*/_jsx(PoweredBy, {}));
    }
    if (logoType === 'premium') {
      return _CrehanaPremium || (_CrehanaPremium = /*#__PURE__*/_jsx(CrehanaPremium, {
        size: 32,
        "aria-hidden": true,
        ignoreColor: true,
        className: "tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
      }));
    }
    if (logoType === 'microdegree') {
      return _CrehanaMicroDegree || (_CrehanaMicroDegree = /*#__PURE__*/_jsx(CrehanaMicroDegree, {
        size: 24,
        "aria-hidden": true,
        ignoreColor: true,
        className: "tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
      }));
    }
    return _Crehana || (_Crehana = /*#__PURE__*/_jsx(Crehana, {
      size: 16,
      "aria-hidden": true,
      ignoreColor: true,
      className: "tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
    }));
  };
  if (urls && urls.home) {
    return /*#__PURE__*/_jsx("a", {
      href: urls.home,
      target: targetLink,
      rel: "noopener noreferrer",
      className: "logo",
      children: renderLogo()
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderLogo()
  });
};
export default Logo;